import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetBijbEventsSuccessAction implements Action {
  public static readonly type = 'GetBijbEventsSuccessAction';

  constructor(public bijbEvents: BijbEvent[]) {
  }

  public type = GetBijbEventsSuccessAction.type;
}
